import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#1a1a2e] text-white mt-20">
      <div className="section-container py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <img
              src="https://customer-assets.emergentagent.com/job_5b158eeb-4f56-49b3-bda9-a91ea3bd8e4f/artifacts/8yol3e91_PSLCOTE-Logo%20%281%29.png"
              alt="PSLCOTE Logo"
              className="h-10 mb-4 brightness-200"
            />
            <p className="text-gray-400 text-sm leading-relaxed">
              Custom-engineered label stock solutions for superior performance and consistency.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Quick Links</h3>
            <div className="space-y-2">
              <Link to="/about" className="block text-gray-400 hover:text-white transition-colors text-sm">
                About Us
              </Link>
              <Link to="/manufacturing" className="block text-gray-400 hover:text-white transition-colors text-sm">
                Manufacturing
              </Link>
              <Link to="/products" className="block text-gray-400 hover:text-white transition-colors text-sm">
                Products
              </Link>
              <Link to="/contact" className="block text-gray-400 hover:text-white transition-colors text-sm">
                Contact
              </Link>
            </div>
          </div>

          {/* Products */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Product Categories</h3>
            <div className="space-y-2 text-sm text-gray-400">
              <p>Pharma & Healthcare</p>
              <p>Wine & Spirits</p>
              <p>Food & Beverages</p>
              <p>Oil & Industrial Chemicals</p>
              <p>Digital Printing Labels</p>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Contact Us</h3>
            <div className="space-y-3 text-sm text-gray-400">
              <div className="flex items-start gap-2">
                <Phone size={16} className="mt-1 flex-shrink-0" />
                <span>+91 9820308238</span>
              </div>
              <div className="flex items-start gap-2">
                <Mail size={16} className="mt-1 flex-shrink-0" />
                <span>sreekumar@pslcote.com</span>
              </div>
              <div className="flex items-start gap-2">
                <MapPin size={16} className="mt-1 flex-shrink-0" />
                <span>Navagraha Group</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-sm text-gray-400">
          <p>&copy; {new Date().getFullYear()} PSLCOTE - Navagraha Group. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;